import { EditIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, Spacer, Text, Image, Heading, Divider, SimpleGrid, Grid, GridItem, ButtonGroup, IconButton, AspectRatio, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import ShortenLinkService from "../../services/shorten/shortenlink-service";
import Clipboard from "components/clipboard";
import AppConsts from "../../libs/appconst";
import Number from "components/number-format";
import BannerService from "../../services/banners/banner-service";
import { BsImage } from "react-icons/bs";
import EditImageDialog from "../../components/edit-image-dialog";
import LogosNotification from "../../utils/notification-utils";
import ConfirmDialog from "../../components/confirm-dialog";

const BannerDetailScene = (): ReactElement => {
    const navigate = useNavigate();
    const { bannerId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [banner, setBanner] = useState<any>(null);
    const { isOpen: isShowChangePosterDialog, onOpen: onShowChangePosterDialog, onClose: onCloseChangePosterDialog } = useDisclosure();
    const { isOpen: isShowDeleteDialog, onOpen: onShowDeleteDialog, onClose: onCloseDeleteDialog } = useDisclosure();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        BannerService.Get(bannerId).then((res: any) => {
            setBanner(res.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleChangePoster = (imageData: any, finallyFunction: any) => {
        BannerService.ChangeBannerImage(bannerId, imageData).then((res: any) => {
            onCloseChangePosterDialog();
            setBanner(res.result);
            LogosNotification.Success("Gambar Banner telah berhasil diperbaharui.");
        }).finally(() => {
            finallyFunction();
        });
    };

    const handleDeleteVoucher = () => {
        setIsDeleting(true);
        BannerService.Delete(bannerId).then((res: any) => {
            LogosNotification.Success("Banner telah berhasil dihapuskan.");
            navigate("/banners");
        }).finally(() => {
            setIsDeleting(false);
        });
    };

    if (isLoading)
        return (<LoadingScreen />)

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Banner {banner.name}</Text>
                        <Spacer />
                        <Button ml={2} variant={"outline"} onClick={() => { navigate(`/banners/${bannerId}/edit`) }}>Edit Banner</Button>
                    </Flex>
                    <Box rounded={'lg'} borderWidth={1} p={8}>
                        <Box>
                            <AspectRatio maxW='600px' ratio={16 / 9} flex={"1 1 auto"}>
                                <Box borderRadius={"md"}>
                                    <Image src={banner.bannerUrl} objectFit='cover' />
                                </Box>
                            </AspectRatio>
                            <IconButton
                                variant={"solid"}
                                colorScheme={'teal'}
                                isRound={true}
                                position={'relative'} bottom={45} ml={1} mb={1}
                                aria-label='Ubah Gamber Banner'
                                icon={<BsImage />}
                                style={{ zIndex: 1 }}
                                onClick={onShowChangePosterDialog}
                            />
                            {
                                isShowChangePosterDialog &&
                                <EditImageDialog onClose={onCloseChangePosterDialog} title="Ubah Gambar Banner" onSubmit={handleChangePoster} aspectRatio={16 / 9} helperText={"Ukuran: 1280 x 720 px"} />
                            }

                            <Box pt={4} pb={2} flex={1}>
                                <Text fontSize={'sm'} color={'gray.500'}>Nama</Text>
                                <Text fontSize={'sm'} fontWeight={'bold'}>{banner.name || '-'}</Text>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Redirect Url</Text>
                                <Clipboard value={banner.redirectUrl || '-'}></Clipboard>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Checkout Url</Text>
                                <Clipboard value={banner.checkoutUrl || '-'}></Clipboard>
                            </Box>
                            <Box py={2} flex={1}>
                                <Text fontSize={'sm'}>Nomor Urutan</Text>
                                <Text fontWeight={"bold"}>{banner.sequence}</Text>
                            </Box>
                            <SimpleGrid columns={{ base: 1, md: 2 }} py={2}>
                                <Box py={0} flex={1}>
                                    <Text fontSize={'sm'}>Buka halaman baru?</Text>
                                    <Text fontWeight={"bold"}>{banner.isRedirectToNewWindow ? "Iya" : "Tidak"}</Text>
                                </Box>
                                <Box py={0} flex={1}>
                                    <Text fontSize={'sm'}>Aktif?</Text>
                                    <Text fontWeight={"bold"} color={banner.status == 0 ? "green" : "red"}>{banner.status == 0 ? "Aktif" : "Tidak Aktif"}</Text>
                                </Box>
                            </SimpleGrid>

                        </Box>

                        <Divider my={5} />

                        <Box>
                            <ButtonGroup gap={2}>
                                <Button onClick={() => navigate(`/banners/${bannerId}/edit`)}>Edit</Button>
                                <Button variant={'outline'} colorScheme={'red'} isLoading={isDeleting} onClick={onShowDeleteDialog}>Hapus</Button>
                                <Button variant={'outline'} onClick={() => { navigate('/banners') }}>Kembali</Button>
                            </ButtonGroup>
                        </Box>
                        {
                            isShowDeleteDialog &&
                            <ConfirmDialog
                                title={'Hapus Banner'}
                                message={`Apakah Anda yakin untuk menghapus Banner ${banner.name}?`}
                                colorScheme={'red'}
                                buttonLabel={'Yakin'}
                                onSubmit={handleDeleteVoucher}
                                onClose={onCloseDeleteDialog}
                                isLoading={isDeleting}
                            />
                        }
                    </Box>
                </Box>
            </Container>
        </Layout >
    );
};

export default BannerDetailScene;